'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _React = require('React');

var _React2 = _interopRequireDefault(_React);

var _reactRedux = require('react-redux');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _reactUtils = require('react-utils');

var _I18nReact = require('I18n.React.FormattedHTMLMessage');

var _I18nReact2 = _interopRequireDefault(_I18nReact);

var _UIUnauthedHubSpotUserAvatar = require('ui-addon-avatars/UIUnauthedHubSpotUserAvatar');

var _UIUnauthedHubSpotUserAvatar2 = _interopRequireDefault(_UIUnauthedHubSpotUserAvatar);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _UIIllustration = require('UIComponents/image/UIIllustration');

var _UIIllustration2 = _interopRequireDefault(_UIIllustration);

var _utils = require('MeetingsLib/utils/utils');

var _BookInfoSelectors = require('MeetingsLib/selectors/BookInfoSelectors');

var _RequestStatusSelectors = require('MeetingsLib/selectors/RequestStatusSelectors');

var _UserProfile = require('MeetingsBase/models/UserProfile');

var _UserProfile2 = _interopRequireDefault(_UserProfile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProfileHeader = _React2.default.createClass({
  displayName: 'ProfileHeader',

  propTypes: {
    // passed
    avatar: _React.PropTypes.string,
    booked: _React.PropTypes.bool.isRequired,
    headline: _React.PropTypes.string,
    profile: _React.PropTypes.instanceOf(_UserProfile2.default).isRequired,
    // loaded
    companyName: _React.PropTypes.string,
    isFetchingCompanyName: _React.PropTypes.bool,
    isFetchingPublicAvailability: _React.PropTypes.bool,
    linkType: _React.PropTypes.string,
    offline: _React.PropTypes.bool
  },

  getDefaultHeadline: function getDefaultHeadline() {
    var _props = this.props,
        profile = _props.profile,
        companyName = _props.companyName,
        linkType = _props.linkType,
        offline = _props.offline,
        isFetchingCompanyName = _props.isFetchingCompanyName;

    var isRoundRobin = (0, _utils.getIsRoundRobin)(linkType);
    if (isRoundRobin && isFetchingCompanyName) {
      return null;
    }
    var suffix = offline ? 'offline' : 'online';
    var headerType = (0, _utils.getHeaderType)(isRoundRobin);
    var options = (0, _utils.getHeaderOptions)(isRoundRobin, companyName, profile);

    return _React2.default.createElement(_I18nReact2.default, {
      message: 'prebook.' + headerType + '.' + suffix,
      options: options
    });
  },
  renderImage: function renderImage() {
    var _props2 = this.props,
        avatar = _props2.avatar,
        booked = _props2.booked,
        isFetchingPublicAvailability = _props2.isFetchingPublicAvailability;


    if (isFetchingPublicAvailability) {
      return this.renderSkeletonImage();
    }
    if (booked) {
      return this.renderBookedImage();
    }
    if (avatar) {
      return this.renderAvatarImage();
    }

    return this.renderUserImage();
  },
  renderBookedImage: function renderBookedImage() {
    return _React2.default.createElement(_UIIllustration2.default, { name: 'success', width: '40%' });
  },
  renderSkeletonImage: function renderSkeletonImage() {
    return _React2.default.createElement('div', { className: 'header-avatar skeleton-image' });
  },
  renderAvatarImage: function renderAvatarImage() {
    var _props3 = this.props,
        avatar = _props3.avatar,
        profile = _props3.profile;

    return _React2.default.createElement(
      'div',
      { className: 'header-avatar' },
      _React2.default.createElement(_UIImage2.default, {
        className: 'image-wrapper',
        src: avatar,
        shape: 'circle',
        alt: profile.fullName,
        size: 'responsive'
      })
    );
  },
  renderUserImage: function renderUserImage() {
    var profile = this.props.profile;

    var email = profile.email;
    if (!email) return null;

    return _React2.default.createElement(_UIUnauthedHubSpotUserAvatar2.default, {
      email: email,
      source: 'meetings-public',
      shape: 'circle',
      size: 'responsive',
      className: 'header-avatar'
    });
  },
  renderMessage: function renderMessage() {
    var _props4 = this.props,
        headline = _props4.headline,
        booked = _props4.booked,
        offline = _props4.offline,
        isFetchingPublicAvailability = _props4.isFetchingPublicAvailability;

    if (isFetchingPublicAvailability) {
      return null;
    }

    if (booked) {
      var suffix = offline ? 'offline' : 'online';
      return _React2.default.createElement(_I18nReact2.default, { message: 'summary.header.' + suffix });
    }

    if (headline) {
      return headline;
    }

    return this.getDefaultHeadline();
  },
  renderHeadline: function renderHeadline() {
    var classes = (0, _reactUtils.classNames)('headline is--heading-2 m-top-4 m-bottom-0 m-x-1 overflow-y-auto', {
      'is--heading-3': this.props.offline,
      'success-header': this.props.booked
    });

    return _React2.default.createElement(
      'span',
      { className: classes, style: { alignSelf: 'stretch' } },
      this.renderMessage()
    );
  },
  render: function render() {
    return _React2.default.createElement(
      _UIFlex2.default,
      {
        direction: 'column',
        align: 'center',
        className: 'profile-header text-center'
      },
      this.renderImage(),
      this.renderHeadline()
    );
  }
});

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    // Rerenders component in response to translation
    activeLocale: state.activeLocale,

    companyName: state.companyName,
    isFetchingCompanyName: (0, _RequestStatusSelectors.getIsFetchingCompanyName)(state),
    isFetchingPublicAvailability: (0, _RequestStatusSelectors.getIsFetchingPublicAvailability)(state),
    linkType: (0, _get2.default)('linkType', (0, _BookInfoSelectors.getBookInfo)(state)),
    offline: (0, _BookInfoSelectors.getOffline)(state)
  };
})(ProfileHeader);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/header/ProfileHeader.js
// module id = 215
// module chunks = 0